module.exports = __webpack_public_path__ + "21cfeaf7ec9dbdb4d48bbf22f71172dd.MP3";